module.exports = __webpack_public_path__ + "img/paper-airplane.946d3174.png";